module.exports = __webpack_public_path__ + "img/ajxq_06.b9290535.jpg";